<script>
    import { showInfo } from "../../../../../Utils/utilFunctions.svelte";
    import {
        getCardiacMbsCodes,
        getMbsItemNumLabel,
        updateConsultItems,
    } from "../../../helpers/mbsHelper.svelte";

    export let itemProps = {},
        defaultItems = [],
        selectedItems = [],
        updateItems = () => {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: if (defaultItems.length) _syncDisplayItems();

    $: if (selectedConsultType) _syncPotentialItems();

    let displayItems = [],
        consultTypes = [],
        selectedConsultType = "";

    const requiredItemsCodes = [17615, 17620, 17625];
    const specialItemCodes = [17690];

    const potentialItemCodeMap = new Map([
        ["Pre-anaesthesia_0", [17610, 17615, 17620, 17625]],
        ["Pre-anaesthesia_1", [17610, 17615, 17620, 17625, 17690]],
        ["Referred", [17640, 17645, 17650, 17655]],
        ["Emergency attendances", [160, 161, 162, 163, 164]],
        ["Telehealth", [92701]],
        ["Pain Medicine (FPM only)", []],
        ["Pre-labour neuraxial", [17680]],
    ]);

    const handleSelectItem = (item) => {
        //check if neuraxial type is Top Up / Revision and selected code is 17680 and block.
        if(itemProps.neuraxialType == 2 && item.itemNum == 17680) {
            showInfo("17680 cannot be used for Top Up | Revision. Please select a Referred consult code.");
            return;
        }
        if(itemProps.neuraxialType == 1 && item.itemNum == 17680 && itemProps.mbsItem17680UsedToday) {
            showInfo("17680 was already used today for this patient. Please select a Referred consult code.");
            return;
        }
        updateItems(
            updateConsultItems(
                item,
                selectedItems,
                undefined,
                isCardiacEncounter,
            ),
        );
    };

    const handleChangeConsultType = () => {
        if (!isCardiacEncounter) return;

        // Remove all items if Consult Type changed for Cardiac encounter
        selectedItems = [];
        updateItems();
    };

    // HELPER FUNCTIONS
    const _syncDisplayItems = () => {
        defaultItems.map((item) => {
            if (
                !consultTypes.some(
                    (type) => type.value == item.infoRegion.toString(),
                )
            )
                _syncConsultTypes(item);
        });

        if (consultTypes.length == 1)
            selectedConsultType = consultTypes[0].value;
        else if (consultTypes.length) {
            selectedConsultType = selectedItems.length
                ? _getSelectedConsultType()
                : (consultTypes.find((type) =>
                      isCardiacEncounter
                          ? type.value == "Anaesthesia" // For Cardiac Consult
                          : type.value == "Referred",
                  )?.value ?? "");
        }
    };

    const _syncConsultTypes = (item) => {
        if (isCardiacEncounter)
            // For Cardiac Consult
            getCardiacMbsCodes().map((code) => {
                if (
                    !consultTypes.length ||
                    !consultTypes.some(
                        (type) => type.label == code.infoRegion.toString(),
                    )
                )
                    consultTypes.push({
                        value: code.infoRegion.toString(),
                        label: code.infoRegion.toString(),
                    });
            });
        else {
            let restrictionArr = [];
            switch (itemProps.billingType) {
                case 0:
                    restrictionArr = ["Pre-anaesthesia"];
                    break;
                case 1:
                    restrictionArr = [
                        "Referred",
                        "Pre-anaesthesia",
                        "Emergency attendances",
                        "Telehealth",
                        "Pain Medicine (FPM only)",
                    ];

                    break;
                case 2:
                    restrictionArr = ["Referred", "Pre-labour neuraxial"];
                    break;
                default:
                    break;
            }

            if (restrictionArr.includes(item.infoRegion.toString()))
                consultTypes.push({
                    value: item.infoRegion.toString(),
                    label: item.infoRegion.toString(),
                });
        }
    };

    const _syncPotentialItems = () => {
        let potentialItemCode = [];

        if (isCardiacEncounter) _getDisplayCardiacConsultItems();
        else {
            switch (selectedConsultType) {
                case "Pre-anaesthesia":
                    potentialItemCode = potentialItemCodeMap.get(
                        `${selectedConsultType}_${itemProps.billingType}`,
                    );
                    break;
                case "Referred":
                case "Emergency attendances":
                case "Telehealth":
                case "Pain Medicine (FPM only)":
                case "Pre-labour neuraxial":
                    potentialItemCode =
                        potentialItemCodeMap.get(selectedConsultType);
                    break;
                default:
                    potentialItemCode = [];
                    break;
            }

            displayItems = _filterItems(potentialItemCode, selectedConsultType);
        }
    };

    const _getDisplayCardiacConsultItems = () => {
        const cardiacItems = getCardiacMbsCodes();

        displayItems = cardiacItems.filter(
            (item) => item.infoRegion == selectedConsultType,
        );
    };

    const _filterItems = (arr = [], infoRegion = "") => {
        if (!arr.length) return [];

        return defaultItems.filter(
            (item) =>
                arr.includes(item.itemNum) && item.infoRegion == infoRegion,
        );
    };

    const _getItemDisabled = (item, selectedItems) => {
        return (
            specialItemCodes.includes(item.itemNum) &&
            !selectedItems.some((item) =>
                requiredItemsCodes.includes(item.itemNum),
            )
        );
    };

    const _getConsultTitle = (arr = []) => {
        if (arr.length != 1) return "";

        return arr[0].label;
    };

    const _getSelectedConsultType = () => {
        if (!isCardiacEncounter){
            if(selectedItems.some((c) => c.infoType == "Consults")) {
                var consultCode = selectedItems.find((c) => c.infoType == "Consults");
                //consult code is selected, try to find a consult type with the same info region
                var selectedItemConsultType = consultTypes.find((type) => type.value == consultCode.infoRegion);
                if(selectedItemConsultType){
                    return selectedItemConsultType.value;
                }
            }
            if(itemProps.billingType == 2 && itemProps.neuraxialType != 2) {
                //for labour epidural, if coudln't match consult type by selected item, show prelabour neuraxial as default if neuraxial type not topup
                return consultTypes.find((c) => c.value == "Pre-labour neuraxial")?.value ?? '';
            }
            return (
                consultTypes[0]?.value ??
                ""
            );
        }
            
        const cardiacConsultTypeMap = new Map();

        const cardiacMbsConsults = getCardiacMbsCodes();

        cardiacMbsConsults.map((consult) => {
            if (!cardiacConsultTypeMap.has(consult.infoRegion))
                cardiacConsultTypeMap.set(consult.infoRegion, [
                    consult.itemNum,
                ]);
            else {
                const types = cardiacConsultTypeMap.get(consult.infoRegion);
                cardiacConsultTypeMap.set(consult.infoRegion, [
                    ...types,
                    consult.itemNum,
                ]);
            }
        });

        const targetConsultType = selectedItems
            .map(
                (item) =>
                    [...cardiacConsultTypeMap].find(([group, numbers]) =>
                        numbers.includes(item.itemNum),
                    )?.[0],
            )
            .find(Boolean);

        return (
            consultTypes.find((type) =>
                targetConsultType
                    ? type.value == targetConsultType.toString()
                    : type.value == "Anaesthesia",
            )?.value ?? ""
        );
    };
</script>

<div class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4">
    <div class="flex flex-1 items-center gap-x-2">
        <p class="w-auto min-w-[6rem] font-bold text-lg">
            {_getConsultTitle(consultTypes)} Consults
        </p>

        {#if !_getConsultTitle(consultTypes)}
            <select
                class="flex-1 select select-md select-bordered"
                bind:value={selectedConsultType}
                on:change={handleChangeConsultType}
            >
                {#each consultTypes as type}
                    <option value={type.value}>
                        {type.label}
                    </option>
                {/each}
            </select>
        {/if}
    </div>

    <div class="flex flex-1 flex-wrap gap-2">
        {#if !isCardiacEncounter}
            {#each displayItems as item}
                <button
                    class={`btn btn-sm rounded rounded-full text-xs hover:btn-primary ${
                        selectedItems.some((itm) => itm.id == item.id)
                            ? "btn-primary"
                            : "btn-secondary"
                    }`}
                    disabled={_getItemDisabled(item, selectedItems)}
                    on:click|preventDefault={() => handleSelectItem(item)}
                >
                    {getMbsItemNumLabel(item)}
                    {item.infoShortTitle}
                </button>
            {/each}
        {:else if selectedConsultType != "TOE"}
            {#each displayItems as item}
                <button
                    class={`btn btn-sm rounded rounded-full text-xs hover:btn-primary ${
                        selectedItems.some((itm) => itm.itemNum == item.itemNum)
                            ? "btn-primary"
                            : "btn-secondary"
                    }`}
                    disabled={_getItemDisabled(item, selectedItems)}
                    on:click|preventDefault={() => handleSelectItem(item)}
                >
                    {getMbsItemNumLabel(item)}
                    {item.infoShortTitle}
                </button>
            {/each}
        {:else}
            <div class="flex flex-col gap-y-2">
                <div class="flex flex-1 gap-x-2 items-center">
                    <p class="w-32">In hospital</p>
                    <div class="flex flex-1 flex-wrap gap-2">
                        {#each displayItems.filter((item) => item.infoSubRegion == "In hospital") as item}
                            <button
                                class={`btn btn-sm rounded rounded-full text-xs hover:btn-primary ${
                                    selectedItems.some(
                                        (itm) => itm.itemNum == item.itemNum,
                                    )
                                        ? "btn-primary"
                                        : "btn-secondary"
                                }`}
                                disabled={_getItemDisabled(item, selectedItems)}
                                on:click|preventDefault={() =>
                                    handleSelectItem(item)}
                            >
                                {getMbsItemNumLabel(item)}
                                {item.infoShortTitle}
                            </button>
                        {/each}
                    </div>
                </div>

                <div class="flex flex-1 gap-x-2">
                    <p class="w-32">Outside hospital</p>
                    <div class="flex flex-1 flex-wrap gap-2">
                        {#each displayItems.filter((item) => item.infoSubRegion == "Outside hospital") as item}
                            <button
                                class={`btn btn-sm rounded rounded-full text-xs hover:btn-primary ${
                                    selectedItems.some(
                                        (itm) => itm.itemNum == item.itemNum,
                                    )
                                        ? "btn-primary"
                                        : "btn-secondary"
                                }`}
                                disabled={_getItemDisabled(item, selectedItems)}
                                on:click|preventDefault={() =>
                                    handleSelectItem(item)}
                            >
                                {getMbsItemNumLabel(item)}
                                {item.infoShortTitle}
                            </button>
                        {/each}
                    </div>
                </div>
            </div>
        {/if}
    </div>
</div>
